<template>
  <th :class="{
  'bg-primary': status === 'distributed',
  'bg-warning': status === 'in_progress',
  'text-white': status === 'distributed',
  'text-white': status === 'bought',
  'bg-dark bg-opacity-25': status === 'bought',
  }">
    <div class="year-wrap">
      <div>{{ year }}</div>
      <small class="year-status">
        {{ statusLabel }}
        <HelpMessage v-if="status === 'in_progress'">
          Распределение долей: март {{ year + 1 }}
        </HelpMessage>
      </small>
    </div>
  </th>
</template>

<script>
import HelpMessage from "./HelpMessage";

const statuses = {
  distributed: 'РАСПРЕДЕЛЕН',
  in_progress: 'АКТИВЕН',
  planned: 'ЗАПЛАНИРОВАН',
  bought: 'ВЫКУПЛЕН',
}

export default {
  name: "Year",
  components: {HelpMessage},
  props: {
    year: Number,
    status: String,
  },

  computed: {
    statusLabel() {
      return statuses[this.status] ?? this.status
    }
  }
}
</script>

<style scoped>
.year-wrap {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.year-status {
  opacity: 0.85;
  font-size: 0.7rem;
  display: inline-flex;
  align-items: center;
}

:deep(.help-btn) {
  background: rgba(0, 0, 0, 0.35) !important;
  color: #fff !important;
  opacity: 1;
}
</style>
